import { api } from './api'

/**
 * A default-language hint from the caller's IP (backend-nest's `/geo/locale`,
 * a local geoIP lookup — no third-party call, no auth). Used only to seed
 * the UI language before the learner has ever chosen one explicitly; a
 * stored manual choice in `prefsStore` always wins over this.
 */
export async function fetchGeoLocale() {
  const { data } = await api.get('/geo/locale')
  return data
}
